module.exports = __webpack_public_path__ + "media/7.9ad84cd4.mp3";